import { AttributeEnum, SkillEnum } from '@hexcrawl/shared-utils';

export const ATTRIBUTE_ICONS: Record<AttributeEnum, string> = {
  [AttributeEnum.MIGHT]:    '💪',
  [AttributeEnum.AGILITY]:  '⚡',
  [AttributeEnum.RESOLVE]:  '🛡️',
  [AttributeEnum.INTELLECT]:'🧠',
  [AttributeEnum.CHARM]:    '🗣️',
};

export const ATTRIBUTE_LABELS: Record<AttributeEnum, string> = {
  [AttributeEnum.MIGHT]:    'Might',
  [AttributeEnum.AGILITY]:  'Agility',
  [AttributeEnum.RESOLVE]:  'Resolve',
  [AttributeEnum.INTELLECT]:'Intellect',
  [AttributeEnum.CHARM]:    'Charm',
};

export const SKILL_ICONS: Record<SkillEnum, string> = {
  [SkillEnum.ATHLETICS]:  '🏃',
  [SkillEnum.STEALTH]:    '👤',
  [SkillEnum.BUSHCRAFT]:  '🌿',
  [SkillEnum.MELEE]:      '⚔️',
  [SkillEnum.RANGED]:     '🏹',
  [SkillEnum.SPELLCRAFT]: '🔮',
  [SkillEnum.LORE]:       '📚',
  [SkillEnum.CRAFT]:      '🔨',
  [SkillEnum.HEALING]:    '❤️‍🩹',
  [SkillEnum.GUILE]:      '🎭',
  [SkillEnum.INSIGHT]:    '👁️',
  [SkillEnum.PERCEPTION]: '👀',
};

export const SKILL_LABELS: Record<SkillEnum, string> = {
  [SkillEnum.ATHLETICS]:  'Athletics',
  [SkillEnum.STEALTH]:    'Stealth',
  [SkillEnum.BUSHCRAFT]:  'Bushcraft',
  [SkillEnum.MELEE]:      'Melee',
  [SkillEnum.RANGED]:     'Ranged',
  [SkillEnum.SPELLCRAFT]: 'Spellcraft',
  [SkillEnum.LORE]:       'Lore',
  [SkillEnum.CRAFT]:      'Craft',
  [SkillEnum.HEALING]:    'Healing',
  [SkillEnum.GUILE]:      'Guile',
  [SkillEnum.INSIGHT]:    'Insight',
  [SkillEnum.PERCEPTION]: 'Perception',
};

export const DERIVED_STAT_ICONS = {
  maxHp:      '❤️',
  maxMp:      '💙',
  combatMove: '👟',
  armor:      '🛡️',
} as const;

export const DERIVED_STAT_LABELS = {
  maxHp:      'Max HP',
  maxMp:      'Max MP',
  hp:         'Hit Points',
  mp:         'Mana Points',
  combatMove: 'Move',
  armor:      'Armor',
} as const;
